/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BonusAccountRespVo } from './BonusAccountRespVo';
import {
    BonusAccountRespVoFromJSON,
    BonusAccountRespVoFromJSONTyped,
    BonusAccountRespVoToJSON,
    BonusAccountRespVoToJSONTyped,
} from './BonusAccountRespVo';

/**
 * 
 * @export
 * @interface ResponseBonusAccountRespVo
 */
export interface ResponseBonusAccountRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseBonusAccountRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseBonusAccountRespVo
     */
    message?: string;
    /**
     * 
     * @type {BonusAccountRespVo}
     * @memberof ResponseBonusAccountRespVo
     */
    data?: BonusAccountRespVo;
}

/**
 * Check if a given object implements the ResponseBonusAccountRespVo interface.
 */
export function instanceOfResponseBonusAccountRespVo(value: object): value is ResponseBonusAccountRespVo {
    return true;
}

export function ResponseBonusAccountRespVoFromJSON(json: any): ResponseBonusAccountRespVo {
    return ResponseBonusAccountRespVoFromJSONTyped(json, false);
}

export function ResponseBonusAccountRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseBonusAccountRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : BonusAccountRespVoFromJSON(json['data']),
    };
}

export function ResponseBonusAccountRespVoToJSON(json: any): ResponseBonusAccountRespVo {
    return ResponseBonusAccountRespVoToJSONTyped(json, false);
}

export function ResponseBonusAccountRespVoToJSONTyped(value?: ResponseBonusAccountRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': BonusAccountRespVoToJSON(value['data']),
    };
}

